module.exports = __webpack_public_path__ + "static/media/painlessLogo.c1cf805e.svg";